// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-border-right .btn{border-right:0!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important;height:calc(1.8rem + 2px);font-size:inherit;line-height:1.3;text-align:left;border-color:rgba(60,60,60,.26)}", ""]);
// Exports
module.exports = exports;
